import { APP_BASE_HREF, PathLocationStrategy, PlatformLocation } from '@angular/common';
import { Inject, Injectable, Optional } from '@angular/core';

@Injectable()
export class PathLocationWithQueryParamsStrategy extends PathLocationStrategy {
  search: string;
  fragment: string;

  private readonly KEY_ACTION = 'ACTION';

  private readonly OVERRIDE_PREFIX = 'OV_';

  constructor(
    _platformLocation: PlatformLocation,
    @Optional() @Inject(APP_BASE_HREF) _baseHref?: string,
  ) {
    super(_platformLocation, _baseHref);
    this.search = _platformLocation.search;
    this.fragment = _platformLocation.hash;
  }

  override prepareExternalUrl(internal: string): string {
    let baseUrl = super.prepareExternalUrl(internal);
    const parameters = this.parseQueryParametersToPersist();
    if (Object.keys(parameters).length > 0) {
      if (!baseUrl.includes(this.search)) {
        baseUrl += this.search;
      }
      if (this.fragment && !baseUrl.includes(this.fragment)) {
        baseUrl += this.fragment;
      }
    }
    return baseUrl;
  }

  /**
   * It parses the query string parameters from the URL and returns the ones that should be persisted in the URL
   * @returns a map of query parameters to persist in the URL
   */
  private parseQueryParametersToPersist(): any {
    const overrideParameters: any = {};
    new URLSearchParams(this.search).forEach((value, key) => {
      if (key === this.KEY_ACTION || key.startsWith(this.OVERRIDE_PREFIX)) {
        overrideParameters[key] = value;
      }
    });
    return overrideParameters;
  }
}
